import { CurrentTimezoneStateService } from './../shared/current-timezone-state.service';
import { Pipe, PipeTransform } from '@angular/core';
// Default import rather than `import * as`: TypeScript 6 rejects calling a
// namespace import (TS2349, "has no call signatures"), and this file calls
// momentTz() directly. Matches how `moment` is already imported below and
// throughout the rest of the codebase.
import momentTz from 'moment-timezone';
import moment from 'moment';

/**
 * timezoneConvertLong Pipe results in: Sep 10, 2021 5:12AM NZDT
 */
@Pipe({
    name: 'timezoneConvertLong',
    standalone: false
})
export class TimezoneConvertPipeLong implements PipeTransform {
  constructor(private cTmzState: CurrentTimezoneStateService) {}

  transform(value: string | number, args?: any): any {
    const currentdate = new Date(value);
    let appCurrentTimezone = this.cTmzState.getCurrentTimezone();

    const localDate = moment
      .utc(currentdate)
      .tz(appCurrentTimezone)
      .format('MMM D, YYYY');

    const localTime = moment
      .utc(currentdate)
      .tz(appCurrentTimezone)
      .format('HH:mm'); // Using 24-hour format here

    const localAbbr = momentTz()
      .tz(appCurrentTimezone)
      .format('z');

    return `${localDate} at ${localTime} ${localAbbr}`;
  }
}

/**
 * timezoneConvertMedium Pipe results in: Sep 10, 2021 NZDT
 */
@Pipe({
    name: 'timezoneConvertMedium',
    standalone: false
})
export class TimezoneConvertPipeMedium implements PipeTransform {
  constructor(private cTmzState: CurrentTimezoneStateService) {}

  transform(value: string | number, args?: any): any {
    const currentdate = new Date(value);
    let appCurrentTimezone = this.cTmzState.getCurrentTimezone();
    const local = moment
      .utc(currentdate)
      .tz(appCurrentTimezone)
      .format('MMM D, YYYY');
    const localAbbr = momentTz()
      .tz(appCurrentTimezone)
      .format('z');
    return local + ' ' + localAbbr;
  }
}

/**
 * timezoneConvertShort Pipe results in: 10/9/2021 NZDT
 */
@Pipe({
    name: 'timezoneConvertShort',
    standalone: false
})
export class TimezoneConvertPipeShort implements PipeTransform {
  constructor(private cTmzState: CurrentTimezoneStateService) {}

  transform(value: string | number, args?: any): any {
    const currentdate = new Date(value);
    let appCurrentTimezone = this.cTmzState.getCurrentTimezone();
    const local = moment
      .utc(currentdate)
      .tz(appCurrentTimezone)
      .format('D/M/YYYY');
    const localAbbr = momentTz()
      .tz(appCurrentTimezone)
      .format('z');
    return local + ' ' + localAbbr;
  }
}

@Pipe({
    name: 'timezoneConvertUTCLong',
    standalone: false
})
export class TimezoneConvertPipeUTCLong implements PipeTransform {
  constructor(private cTmzState: CurrentTimezoneStateService) {}

  transform(value: string | number, args?: any): any {
    const currentdate = new Date(value);
    const local = moment
      .utc(currentdate)
      .format('MMM D, YYYY h:mmA');
    return local + ' UTC';
  }
}

@Pipe({
    name: 'timezoneConvertUTCMedium',
    standalone: false
})
export class TimezoneConvertPipeUTCMedium implements PipeTransform {
  constructor(private cTmzState: CurrentTimezoneStateService) {}

  transform(value: string | number, args?: any): any {
    const currentdate = new Date(value);
    const local = moment
      .utc(currentdate)
      .format('MMM D, YYYY');
    return local + ' UTC';
  }
}

@Pipe({
    name: 'timezoneConvertUTCShort',
    standalone: false
})
export class TimezoneConvertPipeUTCShort implements PipeTransform {
  constructor(private cTmzState: CurrentTimezoneStateService) {}

  transform(value: string | number, args?: any): any {
    const currentdate = new Date(value);
    const local = moment
      .utc(currentdate)
      .format('D/M/YYYY');
    return local + ' UTC';
  }
}
